import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import { MessageSquareHeart } from "lucide-react";

const SURVEY_URL = "https://forms.gle/WC4pULphcUMJdSmK9";

interface FeedbackSurveyModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onTakeSurvey: () => void;
  onMaybeLater: () => void;
}

export const FeedbackSurveyModal = ({
  open,
  onOpenChange,
  onTakeSurvey,
  onMaybeLater,
}: FeedbackSurveyModalProps) => {
  const handleTakeSurvey = () => {
    window.open(SURVEY_URL, "_blank", "noopener,noreferrer");
    onTakeSurvey();
  };

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="px-4 pb-8">
        <DrawerHeader className="text-center pt-6">
          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
              <MessageSquareHeart className="w-7 h-7 text-primary" />
            </div>
          </div>
          <DrawerTitle className="text-xl">
            How was your first Returnify pickup?
          </DrawerTitle>
          <DrawerDescription className="text-base">
            Your feedback helps us improve.
          </DrawerDescription>
        </DrawerHeader>
        <DrawerFooter className="flex flex-col gap-2 pt-4">
          <Button onClick={handleTakeSurvey} className="w-full min-h-[44px]">
            Take 1-minute survey
          </Button>
          <Button
            variant="ghost"
            onClick={onMaybeLater}
            className="w-full min-h-[44px] text-muted-foreground"
          >
            Maybe later
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
